module.exports = __webpack_public_path__ + "static/img/game-logo-ss.1500166.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-ss.png
// module id = B/52
// module chunks = 0 1 2 3 4 5 6